// extracted by mini-css-extract-plugin
export var pageContainer = "_k-1";
export var settingsContent = "_k-0";